import { FILTERDEFAULTS } from 'global/components/filterchips/definitions';
import { cleanCopy } from 'global/utils';

export default {
  data: {
    scorecards: [],
  },
  view: {
    task: {
      new: [],
      ignored: [],
      sent: [],
      list: [],
    },
    alerts: {
      new: [],
      user: [],
      all: [],
    },
    hasLoadedTheme: false,
    hasShownWelcome: false,
    dontAskTaskDelete: false,
    sendReceipt: false,
    style: {
      palette: {
        type: 'light',
      },
    },
    edit: {
      on: false,
    },
    lang: {
      //this acts like a filter, but we are keeping it here because we want it to persist
      id: 'en',
      avail: [
        { id: 'en', title: 'English' },
        { id: 'sp', title: 'Spanish' },
      ],
    },
  },
  filter: cleanCopy(FILTERDEFAULTS),
  auth: {
    permissions: [],
    userId: null,
    email: null,
    accessToken: null,
    refreshToken: null,
    loginFailed: null,
    loginStarted: null,
    accessTokenValidUntil: 0,
    accessTokenSetAt: 0,
    realm: null,
    accountSettings: [],
  },
};
